import { Stack } from '@unifyapps/ui/components/Stack';
import { clsx } from 'clsx';
import type React from 'react';
import type { ReactNode } from 'react';
import { forwardRef } from 'react';
import { BlockDataAttributes } from '../../no-code/hooks/useBlockDataAttributes';

// The page shell, holding no header/workspace/footer imports of its own. Runner pages render it
// directly; ./PageLayout renders through it once it has classified its children.
//
// Deployed apps must not reach ./PageLayout, because classifying children by component identity
// means importing every variant it accepts. Two of those, ManagerPageHeader and
// DetailsPageHeader, pull the platform's project-management stack (RJSF, ajv, avatar uploader)
// into every route that renders a layout, login included.
const PageLayoutShell = forwardRef(function PageLayoutShell(
  {
    children,
    className,
    dataColorScheme,
    pageScopeKey,
    pageId,
  }: {
    children: ReactNode;
    className?: string;
    dataColorScheme?: string;
    pageScopeKey?: string;
    pageId?: string;
  },
  ref?: React.ForwardedRef<HTMLDivElement>,
) {
  return (
    <Stack
      className={clsx('relative h-full overflow-hidden', className)}
      direction="column"
      ref={ref}
      {...{
        [BlockDataAttributes.DataColorSchema]: dataColorScheme,
        [BlockDataAttributes.PageScopeKey]: pageScopeKey,
        [BlockDataAttributes.PageId]: pageId,
      }}
    >
      {children}
    </Stack>
  );
});

export default PageLayoutShell;
